var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaticIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8247E5;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 125,
    cy: 125,
    r: 125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.2,101c-2.5-1.5-5.9-1.5-8.7,0L131.7,113l-13.5,7.8l-19.8,12.1c-2.5,1.5-5.9,1.5-8.7,0l-15.7-9.4 c-2.5-1.5-4.4-4.5-4.4-7.6V97.3c0-3.1,1.5-6,4.4-7.6l15.6-9.2c2.5-1.5,5.9-1.5,8.7,0l15.6,9.2c2.5,1.5,4.4,4.5,4.4,7.6v12.1 l13.5-8.1V89.2c0-3.1-1.5-6-4.4-7.6L98.3,64.2c-2.5-1.5-5.9-1.5-8.7,0L60.4,81.5C57.6,83.1,56,86,56,89.1v34.8c0,3.1,1.5,6,4.4,7.6 l29.3,17.3c2.5,1.5,5.9,1.5,8.7,0l19.8-11.8l13.5-8.1l19.8-11.8c2.5-1.5,5.9-1.5,8.7,0l15.6,9.2c2.5,1.5,4.4,4.5,4.4,7.6v18.7 c0,3.1-1.5,6-4.4,7.6l-15.6,9.4c-2.5,1.5-5.9,1.5-8.7,0l-15.6-9.2c-2.5-1.5-4.4-4.5-4.4-7.6v-12.1l-13.5,8.1v12.1 c0,3.1,1.5,6,4.4,7.6l29.3,17.3c2.5,1.5,5.9,1.5,8.7,0l29.3-17.3c2.5-1.5,4.4-4.5,4.4-7.6v-34.8c0-3.1-1.5-6-4.4-7.6L160.2,101z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaticIcon);
export default __webpack_public_path__ + "static/media/matic_icon.fb1915a97a386b6d0c3b5c129e3e1d06.svg";
export { ForwardRef as ReactComponent };